import * as components from './components';

export default [
    {
        path: '/escalation-tickets',
        component: components.EscalationList,
        name: 'escalationList'
    }
];


// WEBPACK FOOTER //
// ./ClientApp/globalapp/escalationdashboard/routes.js